import { AGTypeError } from './AGTypeError';

export class InvalidSearchTreeError extends AGTypeError {
  static errorName = 'InvalidSearchTreeError';
}
